import { Link } from "react-router-dom";
import ContactForm from "./ContactForm";


export default function GetInTouchSection() {




  return (
    <section className="relative py-12 sm:py-20 px-4 min-h-0 sm:min-h-screen">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1400&q=80')`,
          filter: "brightness(0.4)",
        }}
      />
      <div className="absolute inset-0 bg-black/60" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-8 sm:mb-16">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white px-2 leading-tight">
            Have any Queries? Contact us Today
          </h1>
        </div>

        {/* Two Column Layout */}
        <div className="grid lg:grid-cols-2 gap-0 max-w-6xl mx-auto">
          {/* Left - Info Box */}
          <div className="bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 rounded-t-lg lg:rounded-l-lg lg:rounded-tr-none p-6 sm:p-8 lg:p-12 flex flex-col justify-center relative overflow-hidden">
            {/* Decorative Circles */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-10 right-10 w-32 h-32 border-2 border-white/20 rounded-full" />
              <div className="absolute bottom-20 left-10 w-24 h-24 border-2 border-white/20 rounded-full" />
              <div className="absolute top-1/2 right-1/4 w-16 h-16 border-2 border-white/20 rounded-full" />
            </div>

            <div className="relative z-10 text-center lg:text-left">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">
                Perfect Solution for
                <br />
                your business
              </h2>

              <p className="text-white/90 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                Unlock your business's full potential with our tailored digital solutions. From innovative website
                designs to impactful branding and seamless development
              </p>

              <Link
                to="/contact"
                className="inline-block bg-white text-blue-600 hover:bg-gray-100 font-semibold px-6 py-2.5 sm:px-8 sm:py-3 rounded-lg text-base sm:text-lg transition"
              >
                Get Started
              </Link>
            </div>
          </div>

          {/* Right - Contact Form */}
          <div className="bg-white rounded-b-lg lg:rounded-r-lg lg:rounded-bl-none p-6 sm:p-8 lg:p-12">
           <ContactForm/>
            
          </div>

        </div>
      </div>
    </section>
  );
}
